<template>
  <li class="nav-item dropdown" :class="{ show: open }">

    <a class="nav-link nav-icon" href="#"
       @click.prevent="toggle"
       :class="{ show: open }"
    >
      <i class="bi bi-bell"></i>
      <span class="badge bg-primary badge-number">{{ totalElements }}</span>
    </a>

    <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications" :class="{ show: open }">
      <li class="dropdown-header">
        У вас {{ totalElements }} новых уведомлений
        <a href="#" @click="onRead"><span class="badge rounded-pill bg-primary p-2 ms-2">Прочитано</span></a>
      </li>
      <li>
        <hr class="dropdown-divider">
      </li>


      <li v-for="not in notifications" :key="not.id" class="notification-item">
        <i :class="getClass(not.status)"></i>
        <div>
          <h4>{{ not.title }}</h4>
          <p>{{ not.text }}</p>
          <p>{{ formatLocal(not.createdAt) }}</p>
        </div>
      </li>

      <li>
        <hr class="dropdown-divider">
      </li>
      <li class="dropdown-footer">
        <router-link to="/personal">Посмотреть все</router-link>
      </li>

    </ul>

  </li>
</template>

<script setup>
import { useNotifications } from '@/features/notifications/composables/useNotifications';
import {onMounted, onUnmounted, ref} from "vue";
import { formatLocal } from '@/api/helpers';
const {
    page,
    size,
    startPolling,
    stopPolling,
    markRead,
    load,
    totalElements,
    notifications
} = useNotifications();

page.value = 1;
size.value = 4;

function onRead() {
  markRead();
  load(1, 5, 'NEW');
}

function getClass(status) {
  const map = {
    NEW: "bi bi-check-circle text-success"
  };
  return map[status] ?? "bi bi-exclamation-circle text-warning";
}

onMounted(async () => {
  document.addEventListener("click", close);
  startPolling(2000);
});

const open = ref(false);

function toggle() {
  open.value = !open.value;
}

function close(e) {
  if (!e.target.closest(".nav-item.dropdown")) {
    open.value = false;
  }
}
onUnmounted(() => {
  document.removeEventListener("click", close);
  stopPolling();
});
</script>

<style scoped>

</style>